export default __webpack_public_path__ + "static/media/icon-truck-green.5c03f65a.jpg";